import classNames from 'classnames'

export type Base = {
  isCampaign: boolean
  price?: number | string
  originalPrice?: number | string
  displayVatInfo?: boolean
  stripped?: boolean
  className?: string
  priceVat?: number
  priceClassName?: string
  campaignClassName?: string
}

type Extended = {
  isScreenMinMD?: boolean
  vatInfoPrice?: string
}
type PriceProps = Base & Extended

const Price = ({
  isCampaign,
  price,
  originalPrice,
  displayVatInfo,
  stripped,
  className,
  isScreenMinMD,
  vatInfoPrice,
  priceClassName,
  campaignClassName,
}: PriceProps) => {
  if (!price) {
    return null
  }
  return (
    <div className={className}>
      {isCampaign && (
        <span
          className={classNames('c-price c-price--original', campaignClassName, {
            'd-block': stripped && isScreenMinMD,
          })}>
          {originalPrice}
        </span>
      )}
      <span
        className={classNames('c-price', priceClassName, {
          'c-price--campaign': isCampaign,
        })}>
        {price}
      </span>

      {displayVatInfo && <span className="c-price-vat">{vatInfoPrice}</span>}
    </div>
  )
}

export default Price
